/**
 * Awareness state of one browser tab (spec §7.5), with short keys because it is sent on every cursor move:
 * `u` user, `p` cursor in world coordinates (null when outside the canvas), `s` selection, `v` viewport
 * `[x, y, zoom]` (published only while someone follows this user), `f` id of the user this tab follows. In `u`:
 * `a` the R2 key of the user's photo (P5g), so a new photo shows at once; readers keep only a key under `u/{id}`.
 * `g` the page this tab shows (P14); a tab of an older build sends none and counts as on the first page.
 */
export type PresenceUser = { id: string; n: string; c: string; a?: string };
export type PresenceState = { u: PresenceUser; p: [number, number] | null; s: string[]; v?: [number, number, number]; f?: string | null; g?: string };

/** Cursor publish rate: 10 Hz, 5 Hz beyond five peers, 2 Hz in economy mode (quota tiers, P12). */
export const presenceHz = (peers: number, economy: boolean): number => (economy ? 2 : peers > 5 ? 5 : 10);

/** Cursor coordinates are rounded to 0.5 px: smaller updates, no visible difference. */
export const roundHalf = (v: number): number => Math.round(v * 2) / 2;

const PALETTE = ['#D90429', '#F77F00', '#FCBF49', '#2A9D8F', '#118AB2', '#6A4C93', '#EF476F', '#06D6A0'];

/** A stable colour for users without `profiles.color`. */
export function colorFor(id: string): string {
  let h = 0;
  for (let i = 0; i < id.length; i++) h = (Math.imul(h, 31) + id.charCodeAt(i)) >>> 0;
  return PALETTE[h % PALETTE.length]!;
}
